import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import {
  Job,
  NavigateState,
  YoyakuSbtKbn,
} from '../types/teikihoan/commonDefinition';
import { usePageNavigate } from '../hooks/usePageNavigate';
import { getYoyakuInfo } from '../logics/apiLogic';

export const useHome = () => {
  const location = useLocation().search;
  const paramTokenRef = useRef<string>('');
  const { menuPage, teikihoanPage, kaisenPage, heisenPage, resevationPage } =
    usePageNavigate();
  const urlParams = useRef<NavigateState>();

  //2024.09 COMTEC kawaji MOD START --useEffectをcontrolToPage関数に移動
  useEffect(() => {
    controlToPage();
    // const params = new URLSearchParams(location);
    // //LINEからの遷移の場合、LINEtokenを取得
    // const uParamToken = params.get('token');
    // paramTokenRef.current = uParamToken || '';

    // //////////////////////////////////////////////////////////////
    // // URLパラメータを取得
    // //　・sv: サービス（遷移元）種別　　LINE、HP、うぇぶひだまり等
    // //　・gyomu: 業務種別　　　　　　　定期保安、開栓、閉栓等
    // //　・page: 遷移先画面　　　　　　　menu→メニュー画面、rsv→予約確認画面
    // //　・ma: メールアドレス          HP、うぇぶひだまりから遷移してきた場合、暗号化したメールアドレス
    // //////////////////////////////////////////////////////////////

    // const paramSv = params.get('sv');
    // const paramGyomu = params.get('gyomu');
    // const prmPage = params.get('page');
    // const paramMa = params.get('ma');
    // urlParams.current = {
    //   source: paramSv,
    //   gyomu: paramGyomu,
    //   token: paramTokenRef.current,
    //   mailaddress: paramMa,
    // };

    // if (prmPage) {
    //   if (prmPage === 'menu') {
    //     menuPage({
    //       source: paramSv,
    //       gyomu: paramGyomu,
    //       token: paramTokenRef.current,
    //       mailaddress: paramMa,
    //     });
    //   } else if (prmPage === 'rsv') {
    //     resevationPage({
    //       source: paramSv,
    //       gyomu: paramGyomu,
    //       token: paramTokenRef.current,
    //       mailaddress: paramMa,
    //       yoyakudata: params.get('yoyakudata'),
    //       uketsuke_no: params.get('uno'),
    //       customer_no: params.get('cno'),
    //       kyokyusaki_no: params.get('kno'),
    //     });
    //   } else if (prmPage === 'e-rsv') {
    //     //2024.09.03 COMTEC kawaji ADD START
    //     const yoyakuData = await reservationFromEvent(
    //       params.get('uno') ?? '',
    //       params.get('sbt') ?? ''
    //     );
    //     //2024.09.03 COMTEC kawaji ADD END
    //     resevationPage({
    //       source: paramSv,
    //       gyomu: paramGyomu,
    //       token: paramTokenRef.current,
    //       mailaddress: paramMa,
    //       // yoyakudata: params.get('yoyakudata'),
    //       yoyakudata: yoyakuData,
    //       uketsuke_no: params.get('uno'),
    //       event_sbt: params.get('sbt'),
    //       prepage: 'menu',
    //     });
    //   }
    // } else {
    //   if (paramMa != null) {
    //     if (paramGyomu === Job.Teikihoan) {
    //       teikihoanPage({
    //         source: paramSv,
    //         gyomu: paramGyomu,
    //         token: paramTokenRef.current,
    //         mailaddress: paramMa,
    //       });
    //     } else if (paramGyomu === Job.Kaisen) {
    //       kaisenPage({
    //         source: paramSv,
    //         gyomu: paramGyomu,
    //         token: paramTokenRef.current,
    //         mailaddress: paramMa,
    //       });
    //     } else if (paramGyomu === Job.Heisen) {
    //       heisenPage({
    //         source: paramSv,
    //         gyomu: paramGyomu,
    //         token: paramTokenRef.current,
    //         mailaddress: paramMa,
    //       });
    //     }
    //   }
    // }
  }, []);

  /******************************************
   * URLパラメータを取得し、遷移先画面を制御する
   ******************************************/
  const controlToPage = async () => {
    const params = new URLSearchParams(location);
    //LINEからの遷移の場合、LINEtokenを取得
    const uParamToken = params.get('token');
    paramTokenRef.current = uParamToken || '';

    //////////////////////////////////////////////////////////////
    // URLパラメータを取得
    //　・sv: サービス（遷移元）種別　　LINE、HP、うぇぶひだまり等
    //　・gyomu: 業務種別　　　　　　　定期保安、開栓、閉栓等
    //　・page: 遷移先画面　　　　　　　menu→メニュー画面、rsv→予約確認画面
    //　・ma: メールアドレス          HP、うぇぶひだまりから遷移してきた場合、暗号化したメールアドレス
    //////////////////////////////////////////////////////////////

    const paramSv = params.get('sv');
    const paramGyomu = params.get('gyomu');
    const prmPage = params.get('page');
    const paramMa = params.get('ma');
    const paramGuid = params.get('id'); //2024.09 COMTEC kawaji ADD
    urlParams.current = {
      source: paramSv,
      gyomu: paramGyomu,
      token: paramTokenRef.current,
      mailaddress: paramMa,
      guid: paramGuid, //2024.09 COMTEC kawaji ADD
    };

    if (prmPage) {
      if (prmPage === 'menu') {
        menuPage({
          source: paramSv,
          gyomu: paramGyomu,
          token: paramTokenRef.current,
          mailaddress: paramMa,
          guid: paramGuid, //2024.09 COMTEC kawaji ADD
          event_sbt: params.get('sbt') ?? '', //2024.09 COMTEC kawaji ADD
        });
      } else if (prmPage === 'rsv') {
        resevationPage({
          source: paramSv,
          gyomu: paramGyomu,
          token: paramTokenRef.current,
          mailaddress: paramMa,
          yoyakudata: params.get('yoyakudata'),
          uketsuke_no: params.get('uno'),
          customer_no: params.get('cno'),
          kyokyusaki_no: params.get('kno'),
          prepage: paramGyomu === Job.Heisen ? 'menu' : undefined, //2025.06 COMTEC kawaji ADD
        });
      } else if (prmPage === 'e-rsv') {
        const yoyakuData: {
          result: boolean;
          value: string;
        } = await reservationFromEvent(params.get('uno') ?? ''); //2024.09 COMTEC kawaji ADD
        resevationPage({
          source: paramSv,
          gyomu: paramGyomu,
          token: paramTokenRef.current,
          mailaddress: paramMa,
          yoyakudata: yoyakuData.result ? yoyakuData.value : '', //2024.09 COMTEC kawaji ADD
          uketsuke_no: params.get('uno'),
          event_sbt: params.get('sbt'),
          prepage: 'menu',
          guid: paramGuid, //2024.09 COMTEC kawaji ADD
          msg: yoyakuData.result ? '' : yoyakuData.value, //2024.09 COMTEC kawaji ADD
        });
      }
    } else {
      if (paramMa != null) {
        if (paramGyomu === Job.Teikihoan) {
          teikihoanPage({
            source: paramSv,
            gyomu: paramGyomu,
            token: paramTokenRef.current,
            mailaddress: paramMa,
          });
          //2025.05 COMTEC kawaji DEL START
          // } else if (paramGyomu === Job.Kaisen) {
          //   kaisenPage({
          //     source: paramSv,
          //     gyomu: paramGyomu,
          //     token: paramTokenRef.current,
          //     mailaddress: paramMa,
          //   });
          // } else if (paramGyomu === Job.Heisen) {
          //   heisenPage({
          //     source: paramSv,
          //     gyomu: paramGyomu,
          //     token: paramTokenRef.current,
          //     mailaddress: paramMa,
          //   });
          //2025.05 COMTEC kawaji DEL END
        }
      }
    }
  };
  //2024.09 COMTEC kawaji MOD END

  //2024.09 COMTEC kawaji ADD START
  /******************************************
   *　予約確認画面表示用のフォーマットで予約情報を取得
   ******************************************/
  const reservationFromEvent = async (uketsukeNo: string) => {
    try {
      // if (uketsukeNo === '') return { result: false, value: '' };
      if (
        uketsukeNo === '' ||
        !urlParams.current?.guid ||
        urlParams.current?.guid === ''
      ) {
        return { result: false, value: '' };
      }

      const yoyakuInfo: {
        uketsuke_no: string;
        yoyaku_sbt_cd: YoyakuSbtKbn;
        guid: string; //2024.09 COMTEC kawaji ADD
      } = {
        uketsuke_no: uketsukeNo,
        yoyaku_sbt_cd: YoyakuSbtKbn.event,
        guid: urlParams.current?.guid ?? '', //2024.09 COMTEC kawaji ADD
      };
      const data = await getYoyakuInfo(yoyakuInfo);
      if (data.result === 0) {
        return { result: true, value: JSON.stringify(data.uketsuke_info_list) };
      } else {
        return { result: false, value: data.error_message };
      }
    } catch (e) {
      return { result: false, value: '予約情報取得エラー' };
    }
  };
  //2024.09 COMTEC kawaji ADD END

  const handleTeikihoan = () => {};
  const handleKaisen = () => {};
  const handleHeisen = () => {};
  const handleGasTen = () => {
    menuPage({
      source: urlParams.current?.source ?? '',
      gyomu: urlParams.current?.gyomu ?? '',
      token: paramTokenRef.current,
      mailaddress: urlParams.current?.mailaddress ?? '',
      event_sbt: '002',
      guid: urlParams.current?.guid ?? '', //2024.09 COMTEC kawaji ADD
    });
  };

  //2025.01 COMTEC kawaji ADD START
  const handleHeikaisen = () => {
    menuPage({
      source: urlParams.current?.source ?? '',
      gyomu: urlParams.current?.gyomu ?? '',
      token: paramTokenRef.current,
      mailaddress: urlParams.current?.mailaddress ?? '',
      guid: urlParams.current?.guid ?? '',
    });
  };
  //2025.01 COMTEC kawaji ADD END

  return {
    handleTeikihoan,
    handleKaisen,
    handleHeisen,
    handleGasTen,
    handleHeikaisen, //2025.01 COMTEC kawaji ADD
  };
};
